import { ChevronUpIcon } from '@heroicons/react/24/outline'
import { cn } from 'shared/styles'

export const SortIcon = ({ value }: { value: 'asc' | 'desc' }) => (
  <div>
    <ChevronUpIcon
      className={cn(
        'size-3 stroke-2 hover:text-gray-800',
        value === 'asc' ? 'text-gray-900' : 'text-gray-500',
      )}
    />
    <ChevronUpIcon
      className={cn(
        'size-3 rotate-180 stroke-2 hover:text-gray-800',
        value === 'desc' ? 'text-gray-900' : 'text-gray-500',
      )}
    />
  </div>
)
